// @flow
import aboutUsLoadData from './pages/AboutUs/helpers/aboutUsPageData';
import accountSettingsLoadData from './pages/AccountSettings/helpers/accountSettingsPageData';
import addCreditCardLoadData from './pages/AddCreditCard/helpers/addCreditCardPageData';
import auctionCalendarLoadData from './pages/AuctionCalendar/helpers/auctionCalendarPageData';
import auctionResultsLoadData from './pages/AuctionResults/helpers/auctionResultsPageData';
import biddingConsoleLoadData from './pages/BiddingConsole/helpers/biddingConsolePageData';
import catalogLoadData from './pages/Catalog/helpers/catalogPageData';
import catalogTermsLoadData from './pages/CatalogTerms/helpers/catalogTermsPageData';
import categoryLoadData from './pages/Search/helpers/categoryLandingPageData';
import checkoutConfirmationData from './pages/CheckoutConfirmation/helpers/checkoutConfirmationPageData';
import collectionLoadData from './pages/CuratedCollection/helpers/curatedCollectionPageData';
import consignmentsLoadData from './pages/Consignments/helpers/consignmentsPageData';
import cookiePolicyLoadData from './pages/Cookie/helpers/cookiePolicyPageData';
import directoryLoadData from './pages/SellerDirectory/helpers/sellerDirectoryPageData';
import featuresLoadData from './pages/Features/helpers/featuresPageData';
import homeLoadData from './pages/Home/helpers/homePageData';
import howItWorksLoadData from './pages/HowItWorks/helpers/howItWorksPageData';
import intellectualPropertyLoadData from './pages/IntellectualProperty/helpers/intellectualPropertyPageData';
import itemLoadData from './pages/Item/helpers/itemPageData';
import loadable from '@loadable/component';
// import messagesLoadData from './pages/Messages/helpers/messagesPageData';
// import messengerLoadData from './pages/Messages/helpers/messengerPageData';
import myAuctionsPageData from './pages/MyAuctions/helpers/myAuctionsPageData';
import myBidsLoadData from './pages/MyBids/helpers/myBidsPageData';
import mySavedSearchPageManageLoadData from './pages/MySavedSearch/helpers/mySavedSearchPageData';
import nearMeLoadData from './pages/NearMe/helpers/nearMePageData';
import passwordResetLoadData from './pages/PasswordReset/helpers/passwordResetPageData';
import privacyLoadData from './pages/Privacy/helpers/privacyPageData';
import prServicesLoadData from './pages/PRServices/helpers/prServicesPageData';
import ratingsLoadData from './pages/Ratings/helpers/ratingsPageData';
import recentlyViewedLoadData from './pages/RecentItems/helpers/recentItemsPageData';
import recommendedItemLoadData from './pages/RecommendedItem/helpers/recommendedItemPageData';
import reviewLoadData from './pages/Review/helpers/reviewPageData';
import searchLoadData from './pages/Search/helpers/searchPageData';
import sellerLoadData from './pages/Seller/helpers/sellerPageData';
import sellerTestimonialsLoadData from './pages/SellerTestimonials/helpers/sellerTestimonialsPageData';
import storefrontLoadData from './pages/Storefront/helpers/storeFrontPageData';
import terminologyLoadData from './pages/Terminology/helpers/terminologyPageData';
import termsAndConditionsLoadData from './pages/TermsAndConditions/helpers/termsAndConditionsPageData';
import todayLoadData from './pages/Today/helpers/todayPageData';
import wonItemsLoadData from './pages/WonItems/helpers/wonItemsPageData';

/**
 * Async codesplitting at the route level with @loadable-components
 * @see https://loadable-components.com/docs/dynamic-import/
 */
const AboutUs = loadable(() => import('./pages/AboutUs/AboutUsPageContainer'));
const AuctionCalendar = loadable(() => import('./pages/AuctionCalendar/AuctionCalendarPageContainer'));
const AuctionResults = loadable(() => import('./pages/AuctionResults/AuctionResultsPageContainer'));
const BiddingConsole = loadable(() => import('./pages/BiddingConsole/BiddingConsolePageContainer'));
const Catalog = loadable(() => import('./pages/Catalog/CatalogPageContainer'));
const Category = loadable(() => import('./pages/Search/CategoryLandingPageContainer'));
const Collection = loadable(() => import('./pages/CuratedCollection/CuratedCollectionContainer'));
const Consignments = loadable(() => import('./pages/Consignments/ConsignmentsPageContainer'));
const CookiePolicy = loadable(() => import('./pages/Cookie/CookiePolicyPageContainer'));
const Checkout = loadable(() => import('./pages/Checkout/CheckoutPageContainer'));
const CheckoutConfirmation = loadable(() => import('./pages/CheckoutConfirmation/CheckoutConfirmationPageContainer'));
const Features = loadable(() => import('./pages/Features/FeaturesPageContainer'));
const Home = loadable(() => import('./pages/Home/HomePageContainer'));
const HowItWorks = loadable(() => import('./pages/HowItWorks/HowItWorksPageContainer'));
const IntellectualProperty = loadable(() => import('./pages/IntellectualProperty/IntellectualPropertyPageContainer'));
const Item = loadable(() => import('./pages/Item/ItemPageContainer'));
const OldMessages = loadable(() => import('./pages/Messages-old/MessagesPageContainer'));
const Messages = loadable(() => import('./pages/Messages/MessagesPage'));
const Messenger = loadable(() => import('./pages/Messages/MessengerPage'));
const MyAuctions = loadable(() => import('./pages/MyAuctions/MyAuctionsPageContainer'));
const MyBids = loadable(() => import('./pages/MyBids/MyBidsPageContainer'));
const MySavedSearchPageManage = loadable(() => import('./pages/MySavedSearch/MySavedSearchPageManageContainer'));
const NearMe = loadable(() => import('./pages/NearMe/NearMePageContainer'));
const WonItems = loadable(() => import('./pages/WonItems/WonItemsPageContainer'));
const NotFound = loadable(() => import('./pages/NotFound/NotFound'));
const PasswordReset = loadable(() => import('./pages/PasswordReset/PasswordResetPageContainer'));
const Privacy = loadable(() => import('./pages/Privacy/PrivacyPageContainer'));
const PRServices = loadable(() => import('./pages/PRServices/PRServicesPageContainer'));
const RecommendedItem = loadable(() => import('./pages/RecommendedItem/RecommendedItemPageContainer'));
const RecentlyViewed = loadable(() => import('./pages/RecentItems/RecentItemsPageContainer'));
const Today = loadable(() => import('./pages/Today/TodayPageContainer'));
const Search = loadable(() => import('./pages/Search/SearchPageContainer'));
const Directory = loadable(() => import('./pages/SellerDirectory/SellerDirectoryPageContainer'));
const Seller = loadable(() => import('./pages/Seller/SellerPageContainer'));
const Storefront = loadable(() => import('./pages/Storefront/StorefrontPageContainer'));
const SellerTestimonials = loadable(() => import('./pages/SellerTestimonials/SellerTestimonialsPageContainer'));
const Terminology = loadable(() => import('./pages/Terminology/TerminologyPageContainer'));
const TermsAndConditionsPayments = loadable(() =>
    import('./pages/TermsAndConditions/TermsAndConditionsPaymentsPageContainer')
);
const TermsAndConditions = loadable(() => import('./pages/TermsAndConditions/TermsAndConditionsPageContainer'));
const CatalogTerms = loadable(() => import('./pages/CatalogTerms/CatalogTermsPageContainer'));
const Ratings = loadable(() => import('./pages/Ratings/RatingsPageContainer'));
const Review = loadable(() => import('./pages/Review/ReviewPageContainer'));
const AccountSettings = loadable(() => import('./pages/AccountSettings/AccountSettingsPageContainer'));
const AddCreditCard = loadable(() => import('./pages/AddCreditCard/AddCreditCardPageContainer'));
const SavedFavoritesAndFollowed = loadable(() =>
    import('./pages/FavoritesAndFollowed/FavoritesAndFollowedPageContainer')
);

/**
 * Application route config for react-router-config
 * Each route can optionally have an async loadData function to fetch data during SSR
 *
 * @see https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config#route-configuration-shape
 * @see https://reacttraining.com/react-router/web/guides/server-rendering/data-loading
 */
const routes = (isWhiteLabel: boolean) => [
    // https://localdev.liveauctioneers.com:3443/
    {
        ...(isWhiteLabel
            ? { component: Seller, loadData: sellerLoadData }
            : { component: Home, loadData: homeLoadData }),
        exact: true,
        path: '/',
    },
    // https://localdev.liveauctioneers.com:3443/about
    { component: AboutUs, exact: true, loadData: aboutUsLoadData, path: '/about' },
    // https://localdev.liveauctioneers.com:3443/auction-results
    { component: AuctionResults, exact: true, loadData: auctionResultsLoadData, path: '/auction-results' },
    // https://localdev.liveauctioneers.com:3443/auctioneer/directory
    { component: Directory, exact: true, loadData: directoryLoadData, path: '/auctioneer/directory' },
    // https://localdev.liveauctioneers.com:3443/auctioneer/6341/cloudswood-auction
    { component: Seller, exact: true, loadData: sellerLoadData, path: '/auctioneer/:sellerId/:sellerName' },
    // https://localdev.liveauctioneers.com:3443/auctioneer/6341/cloudswood-auction/reviews
    { component: Ratings, exact: true, loadData: ratingsLoadData, path: '/auctioneer/:sellerId/:sellerName/reviews' },
    // https://localdev.liveauctioneers.com:3443/seller/6341
    { component: Storefront, exact: true, loadData: storefrontLoadData, path: '/seller/:sellerId' },
    // https://localdev.liveauctioneers.com:3443/c/
    { component: Category, exact: true, loadData: categoryLoadData, path: '/c' },
    // https://localdev.liveauctioneers.com:3443/c/drawings/8/
    { component: Category, exact: true, loadData: categoryLoadData, path: '/c/:categoryName/:categoryId' },
    // https://localdev.liveauctioneers.com:3443/c/art/pablo-picasso/1/18755/
    {
        component: Category,
        exact: true,
        loadData: categoryLoadData,
        path: '/c/:categoryName/:categoryName2/:categoryId/:categoryId2',
    },
    // https://localdev.liveauctioneers.com:3443/console/154704_chinese-ceramics-and-works-of-art/
    { component: BiddingConsole, exact: true, loadData: biddingConsoleLoadData, path: '/console/:catalogId' }, // TODO: fix
    // https://localdev.liveauctioneers.com:3443/featured/extraordinary-treasures/26
    {
        component: Collection,
        exact: true,
        loadData: collectionLoadData,
        path: '/featured/:collectionName/:collectionId',
    },
    // https://localdev.liveauctioneers.com:3443/price-guide
    { component: AuctionResults, exact: true, loadData: auctionResultsLoadData, path: '/price-guide' },
    // https://localdev.liveauctioneers.com:3443/price-guide/drawings/8/
    {
        component: Category,
        exact: true,
        loadData: categoryLoadData,
        path: '/price-guide/:categoryName/:categoryId',
    },
    // https://localdev.liveauctioneers.com:3443/catalog/search
    { component: AuctionCalendar, exact: true, loadData: auctionCalendarLoadData, path: '/catalog/search' },
    // // https://localdev.liveauctioneers.com:3443/trending
    { component: Today, exact: true, loadData: todayLoadData, path: '/trending' },
    // https://localdev.liveauctioneers.com:3443/catalog/155755_20th-century-modern-and-contemporary-fine-art/
    { component: Catalog, exact: true, loadData: catalogLoadData, path: '/catalog/:catalogId' },
    // https://localdev.liveauctioneers.com:3443/consignments
    { component: Consignments, exact: true, loadData: consignmentsLoadData, path: '/consignments' },
    // https://localdev.liveauctioneers.com:3443/consignments/6341
    { component: Consignments, exact: true, loadData: consignmentsLoadData, path: '/consignments/:sellerId' },
    // https://localdev.liveauctioneers.com:3443/cookie-policy
    { component: CookiePolicy, exact: true, loadData: cookiePolicyLoadData, path: '/cookie-policy' },
    // https://localdev.liveauctioneers.com:3443/features
    { component: Features, exact: true, loadData: featuresLoadData, path: '/features' },
    // https://localdev.liveauctioneers.com:3443/find-auctions-near-me
    { component: NearMe, exact: true, loadData: nearMeLoadData, path: '/find-auctions-near-me' },
    // https://localdev.liveauctioneers.com:3443/how-it-works
    { component: HowItWorks, exact: true, loadData: howItWorksLoadData, path: '/how-it-works' },
    // https://localdev.liveauctioneers.com:3443/item/78040263_georgian-banded-mahogany-cellarette
    { component: Item, exact: true, loadData: itemLoadData, path: '/item/:itemId' },
    // https://localdev.liveauctioneers.com:3443/password_reset
    { component: PasswordReset, exact: true, loadData: passwordResetLoadData, path: '/password_reset' },
    {
        component: PasswordReset,
        exact: true,
        loadData: passwordResetLoadData,
        path: '/password_reset/:bidderId/:hash',
    },
    // https://localdev.liveauctioneers.com:3443/prservices
    { component: PRServices, exact: true, loadData: prServicesLoadData, path: '/prservices' },
    // https://localdev.liveauctioneers.com:3443/privacy
    { component: Privacy, exact: true, loadData: privacyLoadData, path: '/privacy' },
    // https://localdev.liveauctioneers.com:3443/recent
    { component: RecentlyViewed, exact: true, loadData: recentlyViewedLoadData, path: '/recent' },
    // https://localdev.liveauctioneers.com:3443/search
    { component: Search, exact: true, loadData: searchLoadData, path: '/search' },
    // https://localdev.liveauctioneers.com:3443/seller-testimonials
    { component: SellerTestimonials, exact: true, loadData: sellerTestimonialsLoadData, path: '/seller-testimonials' },
    // https://localdev.liveauctioneers.com:3443/termsandconditionspayments
    {
        component: TermsAndConditionsPayments,
        exact: true,
        path: '/termsandconditionspayments',
    },
    // https://localdev.liveauctioneers.com:3443/termsandconditions
    { component: TermsAndConditions, exact: true, loadData: termsAndConditionsLoadData, path: '/termsandconditions' },
    // https://localdev.liveauctioneers.com:3443/terms/154704_chinese-ceramics-and-works-of-art/
    { component: CatalogTerms, exact: true, loadData: catalogTermsLoadData, path: '/terms/:catalogId' },
    // https://localdev.liveauctioneers.com:3443/terminology
    { component: Terminology, exact: true, loadData: terminologyLoadData, path: '/terminology' },
    // https://localdev.liveauctioneers.com:3443/intellectualproperty
    {
        component: IntellectualProperty,
        exact: true,
        loadData: intellectualPropertyLoadData,
        path: '/intellectualproperty',
    },
    /**
     * Authenticated routes
     */

    {
        component: CheckoutConfirmation,
        exact: true,
        loadData: checkoutConfirmationData,
        path: '/confirmation/:sellerId/:itemId',
    },
    { component: AccountSettings, exact: true, loadData: accountSettingsLoadData, path: '/dashboard/profile' },
    { component: AddCreditCard, exact: true, loadData: addCreditCardLoadData, path: '/dashboard/cardonfile' },
    { component: SavedFavoritesAndFollowed, exact: true, path: '/dashboard/followed-auctioneers' },
    { component: Messages, exact: true, path: '/dashboard/new-messages' },
    { component: OldMessages, exact: true, path: '/dashboard/messages' },
    { component: Messenger, exact: true, path: '/dashboard/new-messages/:conversationId' },
    { component: MyBids, exact: true, loadData: myBidsLoadData, path: '/dashboard/my-bids' },
    { component: MyAuctions, exact: true, loadData: myAuctionsPageData, path: '/dashboard/my-auctions' },
    { component: SavedFavoritesAndFollowed, exact: true, path: '/dashboard/search-and-alerts' },
    {
        component: MySavedSearchPageManage,
        exact: true,
        loadData: mySavedSearchPageManageLoadData,
        path: '/dashboard/search-and-alerts/manage',
    },
    { component: Review, exact: true, loadData: reviewLoadData, path: '/review/:catalogId' },
    { component: SavedFavoritesAndFollowed, exact: true, path: '/dashboard/saved-items' },
    { component: Checkout, exact: true, path: '/checkout/:catalogId' },
    { component: WonItems, exact: true, loadData: wonItemsLoadData, path: '/dashboard/won-items' },
    { component: RecommendedItem, exact: true, loadData: recommendedItemLoadData, path: '/recommended' },
    { component: RecommendedItem, exact: true, loadData: recommendedItemLoadData, path: '/recommended/:amazon' },
    /**
     * Handle 404 pages
     */
    { component: NotFound, exact: true, path: '/not-found' },
    { component: NotFound },
];

export default routes;
